import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSWRConfig } from 'swr'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { toast } from '@/components/ui/use-toast'
import { Api } from './api'
import MultiImageUpload from './MultiImageUpload'

const CreateDialog: React.FC = () => {
  const navigate = useNavigate()
  const { mutate } = useSWRConfig()
  const [open, setOpen] = useState(false)
  const [styleDescription, setStyleDescription] = useState('')
  const [desc, setDesc] = useState('')
  const [imgs, setImgs] = useState<string[]>([])
  const [submitting, setSubmitting] = useState(false)

  const reset = () => {
    setStyleDescription('')
    setDesc('')
    setImgs([])
  }

  const onSubmit = async () => {
    if (!styleDescription.trim()) {
      toast({ variant: 'destructive', title: '请填写需求描述' })
      return
    }
    try {
      setSubmitting(true)
      const res = await Api.create({
        styleDescription: styleDescription.trim(),
        styleReferenceImages: imgs,
        desc: desc.trim(),
      })
      toast({
        title: '已创建',
        className: 'bg-green-500 text-white',
      })
      setOpen(false)
      reset()
      mutate(
        (key) => Array.isArray(key) && key[0] === '/painting-requests',
        undefined,
        { revalidate: true },
      )
      navigate(`/admin/painting-requests/${res.id}`)
    } catch (err: any) {
      toast({
        variant: 'destructive',
        title: '创建失败',
        description: err?.message || '未知错误',
      })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        setOpen(v)
        if (!v) reset()
      }}
    >
      <DialogTrigger asChild>
        <Button>新建绘画需求</Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>新建绘画需求</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>需求描述</Label>
            <Textarea
              value={styleDescription}
              onChange={(e) => setStyleDescription(e.target.value)}
              rows={6}
              placeholder="风格、内容、细节要求等（支持换行）"
            />
          </div>
          <MultiImageUpload
            value={imgs}
            onChange={setImgs}
            label="参考图（可多张）"
          />
          <div className="space-y-2">
            <Label>备注 desc（仅后台，不传飞书）</Label>
            <Textarea
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
              rows={3}
              placeholder="内部备注"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            取消
          </Button>
          <Button onClick={onSubmit} disabled={submitting}>
            {submitting ? '创建中...' : '创建'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default CreateDialog
